<template>
  <div
    id="app"
    :style="fullScreen"
    @click="anchorClick($event)"
    :class="{
      'iphone-safari': isIphoneSafari
    }"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <notifications
      :max="3"
      :position="'top center'"
      :duration="4000"
      :group="'site_notifications'"
    />
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'App',
  data () {
    return {
      fullScreenHeight: window.innerHeight,
      isIphoneSafari: false
    }
  },
  mounted () {
    window.addEventListener('resize', this.reCalcFullScreen)
    if (
      window.navigator.userAgent.toLowerCase().indexOf('iphone') > -1 &&
      window.navigator.userAgent.toLowerCase().indexOf('safari') > -1
    ) {
      this.isIphoneSafari = true
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.reCalcFullScreen)
  },
  methods: {
    reCalcFullScreen (event) {
      this.fullScreenHeight = event.currentTarget.innerHeight
    },
    anchorClick (event) {
      /**
       * Watch for clicks on Firebase file links.
       * We're using an arbitrary convention where all
       * Firebase links start with firebase/
       *
       * Example: firebase/Test File.txt or firebase/some-folder/image.jpg
       *
       * This allows us to hide the full file URL.
       */
      if (event.target.hasAttribute('href')) {
        const href = event.target.getAttribute('href')
        if (
          href.indexOf('firebase/') === 0 ||
          href.indexOf('FIREBASE/') === 0 ||
          href.indexOf('Firebase/') === 0 ||
          href.indexOf('FireBase/') === 0
        ) {
          event.preventDefault()
          const filePath = href.split('firebase/')[1]
          const storage = firebase.storage()
          const fileRef = storage.ref(filePath)
          // Get the download URL
          fileRef.getDownloadURL().then(function (url) {
            window.open(url)
          }).catch(function (error) {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case 'storage/object-not-found':
                console.log('File doesn\'t exist')
                break
              case 'storage/unauthorized':
                console.log('User doesn\'t have permission to access the object')
                break
              case 'storage/canceled':
                console.log('User canceled the upload')
                break
              case 'storage/unknown':
                console.log('Unknown error occurred, inspect the server response')
                break
              default:
                console.log(error.code)
            }
          })
          return false
        }
      }
    }
  },
  computed: {
    fullScreen () {
      return 'height: ' + this.fullScreenHeight + 'px'
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed&family=Barlow:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap');

// 3rd party component styles
@import '~@/scss/v-tooltip';
@import "~@/scss/vuebar";

// app styles
@import '~@/scss/unumApp';
@import '~@/scss/results';
</style>



// WEBPACK FOOTER //
// src/App.vue